module.exports = __webpack_public_path__ + "assets/img/login-bg@3x.e0494b35.png";